import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import cx from "classnames";

import { getAllCurrentDiagnosticQuestions } from "modules/diagnostic/diagnostic-selectors";
import { QuestionKeys } from "modules/diagnostic/diagnostic-constants";
import Actions from "modules/diagnostic/diagnostic-actions";
import IconBody from "../assets/progress-bar-body.svg";

const getAbsoluteProgress = prg =>
  ((Math.pow(Math.E, prg) - Math.pow(Math.E, -prg)) /
    (Math.pow(Math.E, prg) + Math.pow(Math.E, -prg))) *
  100;

class ProgressBar extends Component {
  static propTypes = {
    firstRelativeProgress: PropTypes.number,
    secondRelativeProgress: PropTypes.number,
    jumpToHumanBody: PropTypes.func,
    onExit: PropTypes.func,
    shouldLockBody: PropTypes.bool
  };

  render() {
    const {
      firstRelativeProgress,
      secondRelativeProgress,
      jumpToHumanBody
    } = this.props;
    const firstProgress = jumpToHumanBody
      ? 100
      : getAbsoluteProgress(firstRelativeProgress);
    const secondProgress = getAbsoluteProgress(secondRelativeProgress);
    return (
      <div className="ProgressBar">
        <span className="ProgressBar-close" onClick={this.props.onExit} />
        <span className="ProgressBar-bar">
          <span className="value" style={{ height: firstProgress + "%" }} />
        </span>
        <span
          onClick={jumpToHumanBody}
          className={cx("ProgressBar-icon", "icon-body", {
            active: jumpToHumanBody
          })}
        >
          <svg viewBox="0   0 38 38" xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref={IconBody + "#body"} />
          </svg>
        </span>
        <span className="ProgressBar-bar">
          <span className="value" style={{ height: secondProgress + "%" }} />
        </span>
        <span
          className={cx("ProgressBar-icon", "icon-check", {
            active: secondProgress === 100
          })}
        />
      </div>
    );
  }
}

const AVG_QUESTIONS_AFTER = 15;
const AVG_QUESTIONS_BEFORE = 15;

const mapStateToProps = (state, { shouldLockBody }) => {
  const allQuestions = getAllCurrentDiagnosticQuestions(state);
  const indexOfBody = allQuestions.findIndex(
    question => question.key === QuestionKeys.HUMAN_MODEL
  );

  if (indexOfBody > -1) {
    if (shouldLockBody)
      return {
        firstRelativeProgress: 1,
        secondRelativeProgress: 0,
        humanBodyQuestionId: allQuestions[indexOfBody].id
      };

    return {
      firstRelativeProgress: 1,
      secondRelativeProgress:
        (allQuestions.length - indexOfBody - 1) / AVG_QUESTIONS_AFTER,
      humanBodyQuestionId: allQuestions[indexOfBody].id
    };
  } else {
    return {
      firstRelativeProgress: allQuestions.length / AVG_QUESTIONS_BEFORE,
      secondRelativeProgress: 0
    };
  }
};

const mergeProps = (
  { firstRelativeProgress, secondRelativeProgress, humanBodyQuestionId },
  dispatchProps
) => {
  if (humanBodyQuestionId) {
    return {
      firstRelativeProgress,
      secondRelativeProgress,
      jumpToHumanBody: () => dispatchProps.jumpToHumanBody(humanBodyQuestionId),
      onExit: dispatchProps.onExit
    };
  }
  return {
    firstRelativeProgress,
    secondRelativeProgress,
    onExit: dispatchProps.onExit
  };
};

export default connect(
  mapStateToProps,
  {
    jumpToHumanBody: Actions.Creators.jumpToQuestion,
    onExit: Actions.Creators.onDiagnosticExit
  },
  mergeProps
)(ProgressBar);



// WEBPACK FOOTER //
// ./src/modules/general-info/progress-bar.js